module.exports = __webpack_public_path__ + "static/media/programmers-must-read-books.d490be27.md";